import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import Modal from 'react-modal'

import ImageLoader from '../../ImageLoader'
import ModalCloseButton from '../../ModalCloseButton'

import {closeReviewImageModal} from '../../../actions/reviews'

import * as reviews from '../../../store/reviews'

import '../../../../scss/components/_review-image-modal.scss'

const reviewImageModal = ({imageModalIsOpen, closeImageModal, reviewImage}) => (
  <Modal
    className="review-image-modal-container"
    overlayClassName="review-image-overlay"
    isOpen={imageModalIsOpen}
    onRequestClose={closeImageModal}
    contentLabel="Modal"
  >
    <div>
      <ModalCloseButton onClick={closeImageModal} />
      <ImageLoader role="presentation" src={reviewImage} alt="" />
    </div>
  </Modal>
)

reviewImageModal.propTypes = {
  closeImageModal: PropTypes.func.isRequired,
  imageModalIsOpen: PropTypes.bool.isRequired,
  reviewImage: PropTypes.string,
}

reviewImageModal.defaultProps = {
  reviewImage: null,
}

const mapStateToProps = (state) => ({
  imageModalIsOpen: reviews.reviewImageModalIsOpen(state),
  reviewImage: reviews.currentReviewImage(state),
})

const mapDispatchToProps = (dispatch) => ({
  closeImageModal: () => dispatch(closeReviewImageModal()),
})

export default connect(mapStateToProps, mapDispatchToProps)(reviewImageModal)
